
import { DomainBox } from "@/components/shared/DomainBox";
import { Domain } from "@/types/domain";

interface DomainSectionProps {
  title: string;
  domains: Domain[];
  titleColor: string;
}

// Sample knowledge bases for Chevron domains
const getChevronKnowledgeBases = (symbol: string) => {
  return [
    { title: `${symbol} Standard Operating Procedures`, url: "#" },
    { title: `${symbol} Technical Specifications`, url: "#" },
    { title: `${symbol} Best Practices Guide`, url: "#" }
  ];
};

export const DomainSection = ({ title, domains, titleColor }: DomainSectionProps) => {
  return (
    <div className="mb-8">
      <h2 className={`text-xl font-semibold mb-4 ${titleColor}`}>{title}</h2>
      <div className="grid grid-cols-3 gap-4">
        {domains.map((domain) => (
          <DomainBox
            key={domain.symbol + domain.name}
            domain={domain}
            getKnowledgeBases={getChevronKnowledgeBases}
          />
        ))}
      </div>
    </div>
  );
};
